import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import MainCard from './MainCard'

const MainCardWrapper = ({ children, ...other }) => (
  <MainCard
    sx={{
      maxWidth: '100%',
      margin: { xs: 0.5, md: 3 },
      '& > *': {
        flexGrow: 1,
        flexBasis: '50%',
      },
      borderRadius: '25px',
      ...other.sx,
    }}
    content={false}
    {...other}
  >
    <Box sx={{ p: { xs: 2, sm: 4, xl: 5 } }}>{children}</Box>
  </MainCard>
)

MainCardWrapper.propTypes = {
  children: PropTypes.node,
}

export default MainCardWrapper
